<script setup>
import { Head } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import HeroSection from '@/Components/Landing/HeroSection.vue'
import UniversityStrip from '@/Components/Landing/UniversityStrip.vue'
import OfferSplitSection from '@/Components/Landing/OfferSplitSection.vue'
import TutorRailSection from '@/Components/Landing/TutorRailSection.vue'
import SubjectsSection from '@/Components/Landing/SubjectsSection.vue'
import ParentsProofSection from '@/Components/Landing/ParentsProofSection.vue'
import FinalCtaSection from '@/Components/Landing/FinalCtaSection.vue'

defineProps({
  subjects: { type: Array, default: () => [] },
  featuredTutors: { type: Array, default: () => [] },
  figures: { type: Object, default: () => ({}) },
})
</script>

<template>
  <Head>
    <title>Bindle — elite university tutors for GCSE and A-Level</title>
    <meta
      name="description"
      content="Elite university tutors. Proven academic achievers. Personalised online tutoring that gets results."
    />
  </Head>

  <AppLayout>
    <!--
      Order matters: assurance (where our tutors studied) comes before anything
      is asked of the visitor, the offer comes next, and the tutors themselves
      come before the subject grid — faces convert where a list of subjects does
      not. Sections retired from this page — HowItWorks, Usp, Affordability,
      WhoFor, RecordedContent — said the same thing in five times the space.
    -->
    <HeroSection />
    <UniversityStrip />
    <OfferSplitSection :figures="figures" />
    <TutorRailSection :tutors="featuredTutors" />
    <SubjectsSection :subjects="subjects" />
    <ParentsProofSection :figures="figures" />
    <FinalCtaSection />
  </AppLayout>
</template>
